webpackJsonp([312,253],{

/***/ "Bjes":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("Lpmg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HOC_withBaseComponent__ = __webpack_require__("Cq9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alias_homeRoutes__ = __webpack_require__("hr9z");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NotFound = function (_Component) {
  _inherits(NotFound, _Component);

  function NotFound() {
    var _temp, _this, _ret;

    _classCallCheck(this, NotFound);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.pageKey = 'pv_page_not_found', _temp), _possibleConstructorReturn(_this, _ret);
  }

  NotFound.prototype.navigateToLogin = function navigateToLogin() {
    Object(__WEBPACK_IMPORTED_MODULE_1_preact_router__["route"])(__WEBPACK_IMPORTED_MODULE_4__alias_homeRoutes__["m" /* buyWithInstacredLandingRoute */].path);
  };

  NotFound.prototype.render = function render() {
    var _this2 = this;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': '' + __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.home },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          'class': '' + __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.container,
          onClick: function onClick() {
            return _this2.navigateToLogin();
          } },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
          src: 'https://iccdn.in/img/404-desktop.png',
          'class': '' + __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.desktop
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
          src: 'https://iccdn.in/img/404-mobile.png',
          'class': '' + __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.mobile
        })
      )
    );
  };

  return NotFound;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3__HOC_withBaseComponent__["a" /* default */])(NotFound));

/***/ }),

/***/ "Lpmg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"home":"home__2-7ks","container":"container__3xiv0","desktop":"desktop__uOGiY","mobile":"mobile__3A7lx"};

/***/ })

});


// WEBPACK FOOTER //
// route-page-not-found.chunk.eec31.js